/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useCallback, useState } from 'react';
import styled from 'styled-components/macro';
import { Document, Page, pdfjs } from 'react-pdf';
import {
  useAssignedProduct,
  useAssignedProductsLite,
} from 'app/core/api/product-assignment/api-product-assignment';
import { useUrlParams } from 'app/tools/hooks/misc-hooks';
import _ from 'lodash';
import Button from '../components/button/Button';

const ViewManualContainer = styled.div``;
export default function ViewManual(): JSX.Element {
  const id = +useUrlParams(['id']).id;
  const { resource: asgnProductsLite } = useAssignedProductsLite();
  const {
    resource: asgnProductOrLite = _.find(asgnProductsLite, { id }),
  } = useAssignedProduct(id, { fresh: true });

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(0);

  const onDocumentLoadSuccess = useCallback(document => {
    const { numPages: nextNumPages } = document;
    setNumPages(nextNumPages);
    setPageNumber(1);
  }, []);

  const onItemClick = useCallback(
    ({ pageNumber: nextPageNumber }) => setPageNumber(nextPageNumber),
    []
  );

  const changePage = useCallback(
    offset =>
      setPageNumber(prevPageNumber => (prevPageNumber || 1) + offset),
    []
  );

  const previousPage = useCallback(
    () => changePage(-1),
    [changePage]
  );

  const nextPage = useCallback(() => changePage(1), [changePage]);
  return (
    <ViewManualContainer>
      <Document
        // file="https://iwarrantytemp.s3.eu-west-2.amazonaws.com/Bedienungsanleitung_Husqvarna_LC137i.pdf"
        file={asgnProductOrLite?.productDetails?.userManual}
        onLoadSuccess={onDocumentLoadSuccess}
        onItemClick={onItemClick}
      >
        <Page renderMode="svg" pageNumber={pageNumber} />
        <div
          className="Test__container__content__controls"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
          }}
        >
          <Button
            disabled={pageNumber <= 1}
            onClick={previousPage}
            style={{ minHeight: '40px' }}
          >
            Previous
          </Button>
          <span>
            {`Page ${pageNumber || (numPages ? 1 : '--')} of ${
              numPages || '--'
            }`}
          </span>
          <Button
            disabled={pageNumber >= numPages}
            onClick={nextPage}
            style={{ minHeight: '40px' }}
          >
            Next
          </Button>
        </div>
      </Document>
      {/* <p>
        Page {pageNumber} of {numPages}
      </p> */}
    </ViewManualContainer>
  );
}
